<template>
    <defaultSec class="qw-service-staff-wrap" :title="'企微服务人员'" :isDisableScroll="true">
        <div class="staff-page">
            <div class="summary-row">
                <div class="summary-card">
                    <span class="summary-label">服务人员数</span>
                    <strong>{{ summary.staffCount || 0 }}</strong>
                </div>
                <div class="summary-card is-green">
                    <span class="summary-label">可用人数</span>
                    <strong>{{ summary.enabledCount || 0 }}</strong>
                </div>
                <div class="summary-card is-blue">
                    <span class="summary-label">客户总数</span>
                    <strong>{{ summary.customerCount || 0 }}</strong>
                </div>
                <div class="summary-card is-orange">
                    <span class="summary-label">销售金额</span>
                    <strong>{{ summary.salesAmount || 0 }}</strong>
                </div>
            </div>

            <div class="toolbar">
                <el-form :inline="true" :model="formParam" class="demo-form-inline select-wrap" size="mini">
                    <el-form-item label="手机">
                        <el-input
                            v-model="formParam.distributorPhone"
                            clearable
                            placeholder="输入手机号"
                            @keyup.enter.native="searchList">
                        </el-input>
                    </el-form-item>
                    <el-form-item label="姓名">
                        <el-input
                            v-model="formParam.distributorName"
                            clearable
                            placeholder="输入姓名"
                            @keyup.enter.native="searchList">
                        </el-input>
                    </el-form-item>
                    <el-form-item label="状态">
                        <el-select v-model="formParam.status" clearable placeholder="全部状态">
                            <el-option label="可用" :value="1"></el-option>
                            <el-option label="停用" :value="0"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="平台">
                        <el-select v-model="formParam.platformId" clearable placeholder="全部平台">
                            <el-option label="乐纯小程序" :value="4"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="searchList">查询</el-button>
                        <el-button @click="resetSearch">重置</el-button>
                    </el-form-item>
                </el-form>
                <div class="toolbar-actions">
                    <el-button size="mini" type="success" :loading="syncLoading" :disabled="syncLoading" @click="syncStaff">
                        同步企业微信服务人员
                    </el-button>
                </div>
            </div>

            <div v-if="apiError" class="error-tip">
                <span>服务人员数据加载失败，请稍后重试。</span>
                <el-button size="mini" type="text" @click="initList">重新加载</el-button>
            </div>

            <tablePagination
                :total="total"
                :pageSize="formParam.pageSize"
                :currentPage="formParam.currentPage"
                @handlePage="handlePage">
                <el-table
                    ref="staffTable"
                    v-loading="loading"
                    :data="tableList"
                    border
                    size="mini"
                    :height="tableHeight">
                    <el-table-column label="服务人员" min-width="190" fixed>
                        <template slot-scope="scope">
                            <div class="staff-cell">
                                <img v-if="getAvatar(scope.row)" class="avatar-img" :src="getAvatar(scope.row)" alt="">
                                <span v-else class="avatar-text">{{ getInitial(scope.row) }}</span>
                                <div class="staff-info">
                                    <strong>{{ getName(scope.row) }}</strong>
                                    <span>{{ getRemark(scope.row) || '未填写备注' }}</span>
                                </div>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="手机号" min-width="120">
                        <template slot-scope="scope">
                            {{ scope.row.distributorPhone || scope.row.mobile || '-' }}
                        </template>
                    </el-table-column>
                    <el-table-column label="昵称" min-width="120">
                        <template slot-scope="scope">
                            {{ scope.row.relationNickName || scope.row.nickName || '-' }}
                        </template>
                    </el-table-column>
                    <el-table-column label="组名称" min-width="110">
                        <template slot-scope="scope">
                            {{ scope.row.groupName || '-' }}
                        </template>
                    </el-table-column>
                    <el-table-column label="分享码" min-width="110">
                        <template slot-scope="scope">
                            {{ scope.row.distributorRelationCode || scope.row.shareCode || '-' }}
                        </template>
                    </el-table-column>
                    <el-table-column label="客户数" width="90" align="right">
                        <template slot-scope="scope">
                            {{ getNumberValue(scope.row, ['customerCount', 'customerNum']) }}
                        </template>
                    </el-table-column>
                    <el-table-column label="销售金额" width="100" align="right">
                        <template slot-scope="scope">
                            {{ getNumberValue(scope.row, ['salesAmount', 'saleAmount']) }}
                        </template>
                    </el-table-column>
                    <el-table-column label="状态" width="90">
                        <template slot-scope="scope">
                            <el-tag v-if="isEnabled(scope.row)" size="mini" type="success">可用</el-tag>
                            <el-tag v-else size="mini" type="danger">停用</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column label="创建时间" min-width="155">
                        <template slot-scope="scope">
                            {{ getSyncTime(scope.row) }}
                        </template>
                    </el-table-column>
                    <el-table-column fixed="right" label="操作" width="190">
                        <template slot-scope="scope">
                            <el-button
                                v-if="getDistributorId(scope.row)"
                                type="text"
                                size="mini"
                                @click="showDetail(scope.row)">详情</el-button>
                            <el-tooltip v-else content="缺少人员标识，无法查看详情" placement="top">
                                <span class="disabled-action">详情</span>
                            </el-tooltip>
                            <el-button type="text" size="mini" @click="goCustomer(scope.row)">客户</el-button>
                            <el-button type="text" size="mini" @click="editRemark(scope.row)">备注</el-button>
                        </template>
                    </el-table-column>
                    <div slot="empty" class="empty-box">
                        <i class="el-icon-user"></i>
                        <p>{{ loading ? '数据加载中' : '还没有服务人员' }}</p>
                        <el-button v-if="!loading" size="mini" type="success" :loading="syncLoading" :disabled="syncLoading" @click="syncStaff">
                            同步企业微信服务人员
                        </el-button>
                    </div>
                </el-table>
            </tablePagination>
        </div>

        <el-dialog title="编辑本地备注" :visible.sync="remarkDialogVisible" width="420px">
            <el-form label-width="70px" size="small">
                <el-form-item label="人员">
                    <span>{{ getName(activeStaff) }}</span>
                </el-form-item>
                <el-form-item label="备注">
                    <el-input
                        type="textarea"
                        v-model="remarkForm.remark"
                        :rows="4"
                        maxlength="80"
                        show-word-limit
                        placeholder="填写便于内部识别的备注">
                    </el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button size="small" @click="remarkDialogVisible = false">取消</el-button>
                <el-button size="small" type="primary" :loading="remarkSaving" @click="saveRemark">保存</el-button>
            </span>
        </el-dialog>

        <el-dialog
            title="服务人员详情"
            :visible.sync="detailDialogVisible"
            width="760px"
            :close-on-click-modal="false"
            @closed="resetDetail">
            <div v-loading="detailLoading" class="staff-detail">
                <div v-if="detailError" class="detail-error">
                    <span>{{ detailError }}</span>
                    <el-button size="mini" type="text" @click="loadDetail">重新加载</el-button>
                </div>
                <el-form v-else label-width="150px" size="small" class="detail-form">
                    <el-row :gutter="20">
                        <el-col :span="12"><el-form-item label="平台">{{ getPlatformName(detailData.platformId) }}</el-form-item></el-col>
                        <el-col :span="12"><el-form-item label="姓名">{{ displayValue(detailData.distributorName) }}</el-form-item></el-col>
                        <el-col :span="12"><el-form-item label="手机号">{{ displayValue(detailData.distributorPhone) }}</el-form-item></el-col>
                        <el-col :span="12"><el-form-item label="企微 userId">{{ displayValue(detailData.qyWeixinUserid) }}</el-form-item></el-col>
                        <el-col :span="12"><el-form-item label="挂载员工">{{ displayValue(detailData.qyWeixinUserId) }}</el-form-item></el-col>
                        <el-col :span="12"><el-form-item label="分享码">{{ displayValue(detailData.distributorRelationCode) }}</el-form-item></el-col>
                        <el-col :span="12"><el-form-item label="所属组">{{ displayValue(detailData.groupName) }}</el-form-item></el-col>
                        <el-col :span="12"><el-form-item label="状态">{{ formatBoolean(detailData.status, '可用', '停用') }}</el-form-item></el-col>
                        <el-col :span="12"><el-form-item label="分成比例">{{ displayValue(detailData.percentage) }}</el-form-item></el-col>
                        <el-col :span="12"><el-form-item label="允许抢单">{{ formatBoolean(detailData.robbedable) }}</el-form-item></el-col>
                        <el-col :span="12"><el-form-item label="允许续期">{{ formatBoolean(detailData.renewable) }}</el-form-item></el-col>
                        <el-col :span="12"><el-form-item label="允许邀请自己">{{ formatBoolean(detailData.selfable) }}</el-form-item></el-col>
                        <el-col :span="12"><el-form-item label="允许互相邀请">{{ formatBoolean(detailData.distributorable) }}</el-form-item></el-col>
                        <el-col :span="12"><el-form-item label="创建时间">{{ displayValue(detailData.createTime) }}</el-form-item></el-col>
                    </el-row>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button size="small" @click="detailDialogVisible = false">关闭</el-button>
            </span>
        </el-dialog>
    </defaultSec>
</template>

<script>
import defaultSec from '@c/defaultSection'
import tablePagination from '@c/tablePagination'

export default {
    name: 'qwServiceStaff',
    components: {
        defaultSec,
        tablePagination
    },
    data() {
        return {
            loading: false,
            syncLoading: false,
            remarkSaving: false,
            detailLoading: false,
            apiError: false,
            tableHeight: 420,
            total: 0,
            tableList: [],
            summary: {
                staffCount: 0,
                enabledCount: 0,
                customerCount: 0,
                salesAmount: 0
            },
            formParam: {
                currentPage: parseInt(this.$route.query.currentPage) || 1,
                pageSize: 15,
                recordsTotal: 0,
                groupId: 5,
                status: 1,
                platformId: 4,
                distributorPhone: '',
                distributorName: '',
                pageRouterUrl: 'distributor'
            },
            activeStaff: {},
            remarkForm: {
                userid: '',
                remark: ''
            },
            remarkDialogVisible: false,
            detailDialogVisible: false,
            detailDistributorId: null,
            detailData: {},
            detailError: ''
        }
    },
    mounted() {
        this.initList()
        this.setTableHeight()
        window.addEventListener('resize', this.setTableHeight)
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.setTableHeight)
    },
    methods: {
        initList() {
            this.loading = true
            this.apiError = false
            return this.$apiGet('lechun-cms/qiyeweixin/serviceStaff/page', this.buildListParams()).then(res => {
                const list = res.list || res.records || res.data || []
                this.tableList = list.map(item => this.normalizeStaff(item))
                this.total = res.total || res.recordsTotal || 0
                this.formParam.recordsTotal = this.total
                this.summary = this.normalizeSummary({
                    staffCount: this.total,
                    enabledCount: this.tableList.filter(item => this.isEnabled(item)).length,
                    customerCount: this.sumByKey(this.tableList, ['customerCount', 'customerNum']),
                    salesAmount: this.sumByKey(this.tableList, ['salesAmount', 'saleAmount'])
                })
                this.loading = false
                this.setTableHeight()
            }).catch(() => {
                this.loading = false
                this.apiError = true
                return false
            })
        },
        buildListParams() {
            return {
                ...this.formParam,
                pageRouterUrl: 'distributor'
            }
        },
        normalizeStaff(item) {
            const userid = item.userid || item.userId || item.qyWeixinUserId || item.qyWeixinUserid || item.id || item.distributorId || item.distributorRelationCode || item.shareCode || item.qwId || ''
            const localInfo = this.getLocalStaffInfo(userid)
            return {
                ...item,
                userid: userid,
                name: item.name || item.userName || item.qyWeiXinUserName || item.qwName || item.distributorName || userid,
                status: localInfo.status !== undefined ? localInfo.status : (item.status !== undefined ? item.status : 1),
                remark: localInfo.remark !== undefined ? localInfo.remark : (item.remark || item.localRemark || item.staffRemark || ''),
                customerCount: item.customerCount || item.customerNum || 0,
                salesAmount: item.salesAmount || item.saleAmount || 0,
                lastSyncTime: item.lastSyncTime || item.syncTime || item.updateTime || item.createTime || ''
            }
        },
        normalizeSummary(summary) {
            const data = summary || {}
            return {
                staffCount: data.staffCount || data.totalStaffCount || data.userCount || 0,
                enabledCount: data.enabledCount || data.availableCount || data.enableCount || 0,
                customerCount: data.customerCount || data.externalUserCount || data.customerNum || 0,
                salesAmount: data.salesAmount || data.saleAmount || 0
            }
        },
        searchList() {
            this.formParam.currentPage = 1
            this.pushListRoute(1)
            this.initList()
        },
        resetSearch() {
            this.formParam = {
                currentPage: 1,
                pageSize: 15,
                recordsTotal: 0,
                groupId: 5,
                status: 1,
                platformId: 4,
                distributorPhone: '',
                distributorName: '',
                pageRouterUrl: 'distributor'
            }
            this.pushListRoute(1)
            this.initList()
        },
        handlePage(page) {
            this.formParam.currentPage = page
            this.pushListRoute(page)
            this.initList()
        },
        pushListRoute(page) {
            this.$router.push({path: '/scrm/qwServiceStaff', query: {currentPage: page}}).catch(() => {})
        },
        syncStaff() {
            if (this.syncLoading) {
                return
            }
            this.$confirm('确定从企业微信同步服务人员吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.syncLoading = true
                this.$apiGet('lechun-cms/distributor/getQiyeWeixinFollowUsers').then(() => {
                    this.formParam.currentPage = 1
                    this.pushListRoute(1)
                    return this.initList()
                }).then(success => {
                    this.syncLoading = false
                    if (success === false) {
                        return
                    }
                    this.$message({
                        type: 'success',
                        message: '企业微信服务人员同步成功'
                    })
                }).catch(error => {
                    this.syncLoading = false
                    this.$message.error((error && error.message) || '企业微信服务人员同步失败，请稍后重试')
                })
            }).catch(() => {})
        },
        showDetail(row) {
            const distributorId = this.getDistributorId(row)
            if (!distributorId) {
                this.$message.warning('缺少人员标识，无法查看详情')
                return
            }
            this.detailDistributorId = distributorId
            this.detailData = {}
            this.detailError = ''
            this.detailDialogVisible = true
            this.loadDetail()
        },
        loadDetail() {
            if (!this.detailDistributorId) {
                return
            }
            this.detailLoading = true
            this.detailError = ''
            this.$apiGet('lechun-cms/distributor/getDistributor', {id: this.detailDistributorId}).then(res => {
                this.detailData = res || {}
                this.detailLoading = false
            }).catch(error => {
                this.detailLoading = false
                this.detailError = (error && error.message) || '服务人员详情加载失败，请稍后重试。'
            })
        },
        resetDetail() {
            this.detailDistributorId = null
            this.detailData = {}
            this.detailError = ''
            this.detailLoading = false
        },
        editRemark(row) {
            this.activeStaff = row
            this.remarkForm = {
                userid: this.getUserid(row),
                remark: this.getRemark(row)
            }
            this.remarkDialogVisible = true
        },
        saveRemark() {
            this.remarkSaving = true
            this.saveLocalStaffInfo(this.remarkForm.userid, {remark: this.remarkForm.remark})
            this.tableList = this.tableList.map(item => {
                if (this.getUserid(item) === this.remarkForm.userid) {
                    return {
                        ...item,
                        remark: this.remarkForm.remark
                    }
                }
                return item
            })
            this.$nextTick(() => {
                this.remarkSaving = false
                this.remarkDialogVisible = false
                this.$message({
                    type: 'success',
                    message: '备注已保存'
                })
            })
        },
        goCustomer(row) {
            this.$router.push({
                path: '/scrm/customerList',
                query: {qyWeixinUserid: this.getUserid(row)}
            })
        },
        goChat(row) {
            this.$router.push({
                name: 'chatRecordDetail',
                params: {id: this.getUserid(row)},
                query: {name: this.getName(row)}
            })
        },
        goQrcode(row) {
            this.$router.push({
                path: '/scrm/qrcode',
                query: {qyWeiXinUserId: this.getUserid(row)}
            })
        },
        getName(row) {
            return (row && (row.name || row.userName || row.qyWeiXinUserName || row.qwName || row.distributorName)) || '未命名'
        },
        getUserid(row) {
            return (row && (row.userid || row.userId || row.qyWeixinUserId || row.qyWeixinUserid || row.id || row.qwId)) || ''
        },
        getDistributorId(row) {
            return (row && (row.id || row.distributorId)) || ''
        },
        displayValue(value) {
            return value === undefined || value === null || value === '' ? '-' : value
        },
        formatBoolean(value, trueText = '是', falseText = '否') {
            if (value === undefined || value === null || value === '') {
                return '-'
            }
            return value === 1 || value === '1' || value === true ? trueText : falseText
        },
        getPlatformName(platformId) {
            if (platformId === 4 || platformId === '4') {
                return '乐纯小程序'
            }
            return this.displayValue(platformId)
        },
        getRemark(row) {
            return (row && (row.remark || row.localRemark || row.staffRemark)) || ''
        },
        getAvatar(row) {
            return (row && (row.avatar || row.avatarUrl || row.headImgUrl)) || ''
        },
        getInitial(row) {
            const name = this.getName(row)
            return name ? name.substring(0, 1) : '企'
        },
        getDepartment(row) {
            if (!row) {
                return '-'
            }
            if (Array.isArray(row.departmentNameList)) {
                return row.departmentNameList.join('、') || '-'
            }
            if (Array.isArray(row.departments)) {
                return row.departments.join('、') || '-'
            }
            return row.departmentName || row.department || row.deptName || '-'
        },
        getSyncTime(row) {
            return (row && (row.lastSyncTime || row.syncTime || row.updateTime || row.createTime)) || '-'
        },
        getNumberValue(row, keys) {
            if (!row) {
                return 0
            }
            for (let i = 0; i < keys.length; i++) {
                const key = keys[i]
                if (row[key] !== undefined && row[key] !== null && row[key] !== '') {
                    return row[key]
                }
            }
            return 0
        },
        sumByKey(list, keys) {
            return (list || []).reduce((total, item) => {
                return total + Number(this.getNumberValue(item, keys) || 0)
            }, 0)
        },
        getLocalStorageKey() {
            return 'qwServiceStaffLocalInfo'
        },
        getLocalStaffMap() {
            try {
                return JSON.parse(window.localStorage.getItem(this.getLocalStorageKey()) || '{}')
            } catch (e) {
                return {}
            }
        },
        getLocalStaffInfo(userid) {
            const map = this.getLocalStaffMap()
            return map[userid] || {}
        },
        saveLocalStaffInfo(userid, info) {
            if (!userid) {
                return
            }
            const map = this.getLocalStaffMap()
            map[userid] = {
                ...(map[userid] || {}),
                ...info
            }
            window.localStorage.setItem(this.getLocalStorageKey(), JSON.stringify(map))
        },
        hasCustomerContact(row) {
            if (!row) {
                return false
            }
            if (row.hasCustomerContact !== undefined) {
                return row.hasCustomerContact === 1 || row.hasCustomerContact === true
            }
            if (row.customerContactStatus !== undefined) {
                return row.customerContactStatus === 1 || row.customerContactStatus === true
            }
            return !!row.followUser
        },
        isEnabled(row) {
            if (!row) {
                return false
            }
            const status = row.status
            if (status === undefined || status === null || status === '') {
                return row.enable !== false && row.enabled !== false
            }
            return status === 1 || status === '1' || status === true || status === '可用'
        },
        setTableHeight() {
            this.$nextTick(() => {
                const body = document.querySelector('.qw-service-staff-wrap .default-body')
                const toolbar = document.querySelector('.qw-service-staff-wrap .toolbar')
                const summary = document.querySelector('.qw-service-staff-wrap .summary-row')
                const errorTip = document.querySelector('.qw-service-staff-wrap .error-tip')
                const bodyHeight = body ? body.offsetHeight : 600
                const toolbarHeight = toolbar ? toolbar.offsetHeight : 0
                const summaryHeight = summary ? summary.offsetHeight : 0
                const errorHeight = errorTip ? errorTip.offsetHeight : 0
                this.tableHeight = Math.max(bodyHeight - toolbarHeight - summaryHeight - errorHeight - 78, 260)
                if (this.$refs.staffTable) {
                    this.$refs.staffTable.doLayout()
                }
            })
        }
    }
}
</script>

<style scoped lang="scss" rel="stylesheet/scss">
.qw-service-staff-wrap {
    .staff-page {
        height: 100%;
        display: flex;
        flex-direction: column;
        overflow: hidden;
    }

    .summary-row {
        display: grid;
        grid-template-columns: repeat(4, minmax(150px, 1fr));
        grid-gap: 12px;
        margin-bottom: 12px;
    }

    .summary-card {
        border: 1px solid #e7edf3;
        border-left: 4px solid #8a98a8;
        border-radius: 6px;
        padding: 12px 14px;
        background: linear-gradient(180deg, #ffffff 0%, #fbfcfd 100%);
        box-sizing: border-box;

        .summary-label {
            display: block;
            color: #7a8491;
            font-size: 12px;
            line-height: 18px;
        }

        strong {
            display: block;
            margin-top: 4px;
            color: #242b33;
            font-size: 24px;
            line-height: 30px;
        }
    }

    .is-green {
        border-left-color: #37b24d;
    }

    .is-blue {
        border-left-color: #409eff;
    }

    .is-orange {
        border-left-color: #e6a23c;
    }

    .toolbar {
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        gap: 10px;
        padding: 10px;
        margin-bottom: 10px;
        border: 1px solid #edf1f5;
        border-radius: 6px;
        background: #fafbfc;
        box-sizing: border-box;

        .el-form-item {
            margin-bottom: 8px;
        }

        .el-input,
        .el-select {
            width: 170px;
        }

        .el-date-editor {
            width: 250px;
        }
    }

    .toolbar-actions {
        display: flex;
        flex-shrink: 0;
        gap: 8px;
        padding-top: 1px;

        .el-button + .el-button {
            margin-left: 0;
        }
    }

    .error-tip {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 10px;
        padding: 8px 12px;
        border: 1px solid #f5c6c6;
        border-radius: 5px;
        color: #c45656;
        background: #fef0f0;
        font-size: 12px;
    }

    .disabled-action {
        display: inline-block;
        margin-right: 10px;
        color: #c0c4cc;
        font-size: 12px;
        cursor: not-allowed;
    }

    .staff-detail {
        min-height: 180px;
    }

    .detail-error {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 12px 16px;
        border: 1px solid #f5c6c6;
        border-radius: 4px;
        color: #c45656;
        background: #fef0f0;
    }

    .detail-form {
        padding: 4px 10px 0;

        .el-form-item {
            min-height: 32px;
            margin-bottom: 12px;
            color: #303133;
        }
    }

    .staff-cell {
        display: flex;
        align-items: center;
        min-width: 0;
    }

    .avatar-img,
    .avatar-text {
        width: 34px;
        height: 34px;
        flex: 0 0 34px;
        border-radius: 50%;
    }

    .avatar-img {
        display: block;
        object-fit: cover;
        background: #eef2f5;
    }

    .avatar-text {
        line-height: 34px;
        text-align: center;
        color: #ffffff;
        background: #209e91;
        font-weight: 600;
    }

    .staff-info {
        min-width: 0;
        margin-left: 10px;

        strong,
        span {
            display: block;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }

        strong {
            color: #303133;
            font-size: 13px;
            line-height: 18px;
        }

        span {
            margin-top: 2px;
            color: #909399;
            font-size: 12px;
            line-height: 16px;
        }
    }

    .empty-box {
        padding: 34px 0;
        color: #8a98a8;

        i {
            font-size: 30px;
            color: #c4ccd5;
        }

        p {
            margin: 8px 0 12px;
            font-size: 13px;
        }
    }
}

@media screen and (max-width: 900px) {
    .qw-service-staff-wrap {
        .summary-row {
            grid-template-columns: repeat(2, minmax(130px, 1fr));
        }

        .toolbar {
            display: block;
        }

        .toolbar-actions {
            margin-top: 4px;
            flex-wrap: wrap;
        }
    }
}
</style>
